import { observable } from "mobx";
import { api } from "../../api";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";

export class SpedImportTxt {
  obs = observable({
    importarTxts: false as boolean,
    loadingImport: false as boolean,
    loading: false as boolean,
    tasks_sped: [] as any[],
    length_tasks_sped: 0 as number
  })

  constructor() {
  }

  async handleDownloadArquivoRelatorio(id: string, cnpj: string, format: string) {
    
    this.obs.loading = true

    try {

      let resp = await api.post(`/api/relatorio/task/download_file_sped`, {id: id, format: format}, { responseType: 'blob' });

      if(resp.status == 200){

        const fileName = cnpj + "_relatorio." + format;

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error('Erro ao baixa o arquivo, tente novamente mais tarde ou contate o suporte.', {});

    }

    this.obs.loading = false
  }

  async handldeCreateTaskImport(data) {

    this.obs.loadingImport = true

    try {
      let resp = await api.post("/api/relatorio/import-txt-sped", data);

      if (resp.data.ok == false) {
        toast.warning(resp.data.erro, {});
      } else {
        toast.success('Importado com sucesso!', {});
      }

      this.obs.importarTxts = false;

    } catch (ex) {
      
      toast.error("Erro ao realizar importação, tente novamente mais tarde.", {});

    }

    this.obs.loadingImport = false

  }

  async handleConsulta(paged: number, cnpj: string) {

    try {

      let data = {
        cnpj: cnpj,
        page: paged,
        limit: 15
      }

      let resp = await api.post("/api/relatorio/index-sped", data);

      this.obs.tasks_sped = [];
      this.obs.length_tasks_sped = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_sped = resp.data.itens
        this.obs.length_tasks_sped = resp.data.count
      }

    } catch (ex) {

      toast.error("Erro ao tarefas, tente novamente mais tarde.", {});

    }

  }
}

export const SpedImportTxtStore = new SpedImportTxt();
